import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  normalize() {
    const [year, month, day] = this.inputTarget.value.split("-")
    const shortYear = Number(year)

    if (!month || !day || shortYear < 1 || shortYear >= 100) return

    const currentYear = new Date().getFullYear()
    const normalizedYear = currentYear - (currentYear % 100) + shortYear
    this.inputTarget.value = `${normalizedYear}-${month}-${day}`
  }
}
